import api from "./API";
import ApiEndpointConstants, {
  DEFAULT_CONTENT_IDS,
  DEFAULT_CONTENT_TYPE,
  DEFAULT_CONTENTS_TITLE,
  POST_MEASSGE_GROUP_ID,
} from "../constants/ApiEndpointConstants";
import LocalStorageUtil from "../utils/LocalStorageUtil";
import cookie from "react-cookies";
import { getFbPixel } from "./GetPixelAPI";
import { postMessage } from "./PostMessageAPI";
import { initGoogleAds } from "../utils/googleTag";
import { initFacebookPixel } from "../utils/facebookTag";
import { initTikTokPixel, trackTikTokPixelEvent } from "../utils/tiktokTag";
import { generateEventId } from "../utils/RandomGeneratorUtils";
import { countPixelEvent } from "./CountPixelEventAPI";
import getWWWUrl from "../utils/getWWWUrl";
import { setTrackingSiteUrl } from "../utils/trackingSiteContext";
import { setConfig } from "@/store/configSlice";
import { store } from "../store";

let activeTrackingConfig = null;
let trackingInitializationKey = "";
let trackingInitializationPromise = null;
const trackingConfigCache = new Map();
const trackedPageViews = new Set();

const getActiveTrackingConfig = () =>
  activeTrackingConfig || store.getState()?.configs?.config || null;

const normalizeAdPlatform = (value) => {
  const platform = String(value || "")
    .trim()
    .toLowerCase();
  if (platform === "facebook" || platform === "meta") return "Facebook";
  if (platform === "google") return "Google";
  const compactPlatform = platform.replace(/[\s_-]/g, "");
  if (compactPlatform === "tiktok" || compactPlatform === "tiktokads") {
    return "TikTok";
  }
  return "";
};

export function normalizeTrackingConfig(data, siteUrl = "") {
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;

  const normalizedSiteUrl = getWWWUrl(
    String(siteUrl || data.siteUrl || data.url || "").trim(),
  );
  if (!normalizedSiteUrl) return null;

  return {
    siteUrl: normalizedSiteUrl,
    tgid: data.tgid || "",
    fbqToken: data.fbqToken || "",
    pixel: data.pixel || "",
    amount: data.amount || "",
    amount_fast: data.amount_fast || "",
    groupid: data.groupid || "",
    googlePixel: data.googlePixel || "",
    googleConversionLabel: data.googleConversionLabel || "",
    tiktokPixel:
      data.tiktokPixel ||
      data.tikTokPixel ||
      data.tiktok_pixel ||
      data.tiktok_pixel_id ||
      "",
    adPlatform: normalizeAdPlatform(data.adPlatform),
  };
}

const activateTrackingConfig = (config) => {
  activeTrackingConfig = config;
  setTrackingSiteUrl(config.siteUrl);
  store.dispatch(setConfig(config));
};

// 获取配置
export async function getConfigFromUrl(siteUrl) {
  if (!siteUrl) return null;

  const newUrl = getWWWUrl(siteUrl);

  const res = await getFbPixel(newUrl);
  const data = res?.data?.data;
  if (!data) return null;

  return normalizeTrackingConfig(data, newUrl);
}

export const Facebook = (
  event_id,
  eventname,
  customdata,
  userdata,
  fbqToken,
  pixel,
  orderNu,
) => {
  let _fbc = cookie.load("_fbc", { path: "/" });
  let _fbp = cookie.load("_fbp", { path: "/" });
  _fbc = _fbc ? _fbc : "";
  _fbp = _fbp ? _fbp : "";
  userdata["fbc"] = _fbc;
  userdata["fbp"] = _fbp;

  if (!userdata.client_ip_address) {
    delete userdata.client_ip_address;
  }
  if (!userdata.client_user_agent) {
    delete userdata.client_user_agent;
  }

  return api.post(`${ApiEndpointConstants.FACEBOOK}`, {
    event_id: event_id,
    eventname: eventname,
    customdata: customdata,
    userdata: userdata,
    fbqToken: fbqToken,
    pixel: pixel,
    orderNu: orderNu,
  });
};

export const submitFBConversionEvent = async (
  eventname,
  customdata,
  userdata,
  event_id,
  orderNu,
) => {
  let _fbc = cookie.load("_fbc", { path: "/" });
  let _fbp = cookie.load("_fbp", { path: "/" });
  const config = getActiveTrackingConfig();
  if (!config) return;

  const fbclid = LocalStorageUtil.loadFbclid();
  const entryTimestamp = LocalStorageUtil.loadEntryTimestamp();
  if (!_fbc || (_fbc && _fbc.trim() === "")) {
    if (fbclid && fbclid.trim() !== "") {
      // 手动根据 fbclid 生成fbc参数
      if (entryTimestamp && entryTimestamp.trim() !== "") {
        _fbc = `fb.1.${entryTimestamp}.${fbclid}`;
      } else {
        const now = new Date().getTime();
        _fbc = `fb.1.${now}.${fbclid}`;
      }
    }
  }

  _fbc = _fbc ? _fbc : "";
  _fbp = _fbp ? _fbp : "";

  if (!userdata) {
    userdata = {
      em: "",
      ph: "",
      fn: "",
      ln: "",
      ct: "",
      st: "",
      zp: "",
      country: "",
      external_id: "",
      fbc: _fbc,
      fbp: _fbp,
    };
  } else {
    userdata = Object.assign({}, userdata, { fbc: _fbc, fbp: _fbp });
  }

  const formatCustomData = Object.assign({}, customdata, {
    content_ids: DEFAULT_CONTENT_IDS,
    content_name: DEFAULT_CONTENTS_TITLE,
    content_type: DEFAULT_CONTENT_TYPE,
    contents: [
      {
        id: DEFAULT_CONTENT_IDS[0],
        title: DEFAULT_CONTENTS_TITLE,
        quantity: 1,
      },
    ],
    currency: "USD",
    num_items: 1,
  });
  let res = api.post(`${ApiEndpointConstants.FACEBOOK}`, {
    eventname,
    customdata: formatCustomData,
    userdata,
    event_id,
    orderNu,
    pixel: config.pixel,
    fbqToken: config.fbqToken,
  });
  let resData = res?.data;
  postMessage(
    `[--Facebok - ${eventname} | event_id : ${event_id}--]:${resData}`,
    POST_MEASSGE_GROUP_ID,
  );
  return res;
};

export const submitGGconversionEvent = async (eventName, params = {}) => {
  const config = getActiveTrackingConfig();
  if (!config) return;

  const adPlatform = config.adPlatform;
  if (adPlatform === "Google") {
    if (typeof window.gtag !== "function") {
      postMessage(
        `[Google] gtag not initialized: ${eventName}`,
        POST_MEASSGE_GROUP_ID,
      );
      return;
    }
    window.gtag("event", eventName, params);
  }
};

export const submitTikTokConversionEvent = (eventName, params = {}) => {
  const config = getActiveTrackingConfig();
  if (config?.adPlatform !== "TikTok" || !config.tiktokPixel) return false;

  const tracked = trackTikTokPixelEvent(config.tiktokPixel, eventName, params);
  if (!tracked) {
    postMessage(
      `[TikTok] ttq not initialized: ${eventName}`,
      POST_MEASSGE_GROUP_ID,
    );
  }
  return tracked;
};

export async function initTracking(
  siteUrl,
  sessionId = "",
  embeddedConfig = null,
) {
  const normalizedSiteUrl = getWWWUrl(siteUrl);
  if (!normalizedSiteUrl) return null;

  const suppliedConfig = normalizeTrackingConfig(
    embeddedConfig,
    normalizedSiteUrl,
  );
  const hasSuppliedTrackingConfig = Boolean(
    suppliedConfig &&
    (suppliedConfig.pixel ||
      suppliedConfig.googlePixel ||
      suppliedConfig.tiktokPixel ||
      suppliedConfig.fbqToken ||
      suppliedConfig.adPlatform),
  );
  const sessionConfig = hasSuppliedTrackingConfig ? suppliedConfig : null;
  const configFingerprint = sessionConfig
    ? [
        sessionConfig.adPlatform,
        sessionConfig.pixel,
        sessionConfig.googlePixel,
        sessionConfig.tiktokPixel,
      ].join(":")
    : "remote";
  const initializationKey = `${normalizedSiteUrl}::${sessionId}::${configFingerprint}`;
  if (
    trackingInitializationKey === initializationKey &&
    trackingInitializationPromise
  ) {
    return trackingInitializationPromise;
  }

  activeTrackingConfig = null;
  setTrackingSiteUrl(normalizedSiteUrl);
  store.dispatch(setConfig({}));
  trackingInitializationKey = initializationKey;
  trackingInitializationPromise = (async () => {
    const config =
      sessionConfig ||
      trackingConfigCache.get(initializationKey) ||
      (await getConfigFromUrl(normalizedSiteUrl));
    if (!config) return null;

    trackingConfigCache.set(initializationKey, config);
    activateTrackingConfig(config);

    const adPlatform = config.adPlatform;
    const shouldTrackPageView = !trackedPageViews.has(initializationKey);

    if (adPlatform === "Google" && config.googlePixel) {
      initGoogleAds(config.googlePixel);
    }
    if (adPlatform === "Facebook" && config.pixel) {
      initFacebookPixel(config.pixel, { trackPageView: shouldTrackPageView });
    }
    if (adPlatform === "TikTok" && config.tiktokPixel) {
      initTikTokPixel(config.tiktokPixel, {
        trackPageView: shouldTrackPageView,
      });
    }

    if (shouldTrackPageView) {
      trackedPageViews.add(initializationKey);
      const eventId = generateEventId("PageView", DEFAULT_CONTENT_IDS[0]);
      countPixelEvent("Page View", eventId)?.catch?.((error) => {
        console.warn("Tracking event failed: Page View", error);
      });
    }

    return config;
  })();

  try {
    return await trackingInitializationPromise;
  } catch (error) {
    if (trackingInitializationKey === initializationKey) {
      trackingInitializationKey = "";
      trackingInitializationPromise = null;
    }
    throw error;
  }
}
